import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { PagesComponent } from './pages.component';
import {
  HeaderModule,
  MessagesModule,
  ModalComponent,
  ModalModule,
  CustomModalModule,
  CustomModalComponent,
  ModalService,
  SettingsModule,
  SidebarModule,
  CustomModalService,
} from 'beyond-util';
import { routing } from './pages.routing';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { RtsModule } from './rts/rts.module';
import { AppSettingsService } from '../services/app-settings.service';
@NgModule({
  declarations: [PagesComponent],
  entryComponents: [ModalComponent, CustomModalComponent],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    LoadingBarHttpClientModule,
    HeaderModule,
    SidebarModule,
    SettingsModule,
    MessagesModule,
    ModalModule,
    CustomModalModule,
    RtsModule,
    routing,
  ],
  providers: [ModalService, CustomModalService, AppSettingsService],
  exports: [PagesComponent],
})
export class PagesModule {}



// WEBPACK FOOTER //
// ./src/app/pages/pages.module.ts